/* Patita Limpia — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.pl-reveal:not(.pl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-pl-contar]');
    if (!nums.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-pl-contar')) || 0;
      var dur = parseInt(el.getAttribute('data-pl-duracion'), 10) || 1600;
      if (reduce) { el.textContent = fin.toLocaleString('es-MX'); return; }
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v.toLocaleString('es-MX');
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initCarruseles() {
    document.querySelectorAll('[data-pl-carrusel]').forEach(function (wrap) {
      var pista = wrap.querySelector('.pl-usos__pista');
      if (!pista) return;
      wrap.querySelectorAll('[data-pl-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = pista.querySelector('.pl-uso');
          var paso = item ? item.getBoundingClientRect().width + 20 : 300;
          pista.scrollBy({ left: paso * parseInt(btn.getAttribute('data-pl-dir'), 10), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-pl-producto]').forEach(function (root) {
      var principal = root.querySelector('.pl-prod__principal img');
      root.querySelectorAll('.pl-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = mini.getAttribute('data-src');
            principal.srcset = mini.getAttribute('data-srcset') || '';
            principal.alt = mini.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
          root.querySelectorAll('.pl-prod__mini').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });

      var cant = root.querySelector('.pl-prod__cant input');
      root.querySelectorAll('[data-pl-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!cant) return;
          var v = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-pl-cant'), 10));
          cant.value = v;
        });
      });

      var dataEl = root.querySelector('[data-pl-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var precioEl = root.querySelector('[data-pl-precio]');
      var antesEl = root.querySelector('[data-pl-antes]');
      var boton = root.querySelector('[data-pl-boton]');
      var barraPrecio = document.querySelector('[data-pl-barra-precio]');
      if (dataEl && idInput) {
        var variantes = JSON.parse(dataEl.textContent);
        var formato = root.getAttribute('data-pl-moneda') || '$';
        root.querySelectorAll('.pl-prod__opcion input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('.pl-prod__opcion').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              sel.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) {
              boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-nodisp');
              return;
            }
            idInput.value = v.id;
            var dinero = function (c) { return formato.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
            if (precioEl) precioEl.textContent = dinero(v.price);
            if (barraPrecio) barraPrecio.textContent = dinero(v.price);
            if (antesEl) {
              if (v.compare_at_price && v.compare_at_price > v.price) { antesEl.textContent = dinero(v.compare_at_price); antesEl.hidden = false; }
              else antesEl.hidden = true;
            }
            boton.disabled = !v.available;
            boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt') : boton.getAttribute('data-txt-agotado');
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      // Añadir al carrito sin salir de la página (abre el carrito de Dawn si existe)
      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          var err = root.querySelector('.pl-prod__error');
          ev.preventDefault();
          if (boton) boton.disabled = true;
          var fd = new FormData(form);
          if (drawer && drawer.getSectionsToRender) {
            fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (boton) boton.disabled = false;
            if (res.status) { if (err) err.textContent = res.description || res.message; return; }
            if (err) err.textContent = '';
            if (drawer && drawer.renderContents) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      // Barra fija en móvil cuando el botón principal sale de pantalla
      var barra = document.querySelector('.pl-barra');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(boton);
        var barraBtn = barra.querySelector('button');
        if (barraBtn) barraBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
      }
    });
  }

  function init() { initReveal(); initCifras(); initCarruseles(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCifras(); initCarruseles(); });
})();
